// MINDSTATE - Size table drawer (mobile native style)
// Klonuje istniejący .custom-size-table-wrapper z accordion do drawera od dołu.
(function () {
  'use strict';

  let drawer, backdrop;

  function buildTriggerButton() {
    const btn = document.createElement('button');
    btn.className = 'ms-size-trigger';
    btn.type = 'button';
    btn.setAttribute('aria-label', 'Otwórz tabelę rozmiarów');
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M21 6H3v12h18V6z"/><path d="M7 6v3M11 6v4M15 6v3M19 6v4"/>' +
      '</svg>' +
      '<span>Tabela rozmiarów</span>';
    btn.addEventListener('click', openDrawer);
    return btn;
  }

  function buildHeader() {
    const fieldset = document.querySelector('variant-picker fieldset.variant-option--buttons');
    if (!fieldset) return;
    if (fieldset.parentElement.querySelector('.ms-size-header')) return;

    const legend = fieldset.querySelector('legend');
    const labelText = (legend?.textContent || 'Rozmiar').trim();

    const header = document.createElement('div');
    header.className = 'ms-size-header';
    header.innerHTML = '<span class="ms-size-header__label">' + labelText + '</span>';
    header.appendChild(buildTriggerButton());

    fieldset.parentElement.insertBefore(header, fieldset);
  }

  function buildDrawer() {
    if (document.getElementById('ms-size-drawer')) return;

    backdrop = document.createElement('div');
    backdrop.className = 'ms-size-backdrop';
    backdrop.addEventListener('click', closeDrawer);

    drawer = document.createElement('div');
    drawer.id = 'ms-size-drawer';
    drawer.className = 'ms-size-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-labelledby', 'ms-size-drawer-title');
    drawer.innerHTML =
      '<div class="ms-size-drawer__handle" aria-hidden="true"></div>' +
      '<div class="ms-size-drawer__header">' +
        '<h3 class="ms-size-drawer__title" id="ms-size-drawer-title">Tabela rozmiarów</h3>' +
        '<button class="ms-size-drawer__close" type="button" aria-label="Zamknij">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true">' +
          '<path d="M6 6l12 12M18 6L6 18"/>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="ms-size-drawer__body"></div>';

    drawer.querySelector('.ms-size-drawer__close').addEventListener('click', closeDrawer);
    document.body.appendChild(backdrop);
    document.body.appendChild(drawer);
  }

  function openDrawer() {
    const wrapper = document.querySelector('.custom-size-table-wrapper');
    if (!wrapper) return;

    const body = drawer.querySelector('.ms-size-drawer__body');
    body.innerHTML = '';
    const clone = wrapper.cloneNode(true);
    body.appendChild(clone);

    // Wykryj liczbę kolumn z pierwszego wiersza - ustaw CSS var
    const firstRow = clone.querySelector('div > div');
    if (firstRow && firstRow.children.length > 1) {
      clone.style.setProperty('--cols', firstRow.children.length - 1);
    }

    backdrop.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('ms-size-drawer-open');
  }

  function closeDrawer() {
    if (!drawer) return;
    backdrop.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.classList.remove('ms-size-drawer-open');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  function hideAccordionSection() {
    document.querySelectorAll('details').forEach(function (d) {
      const sum = d.querySelector('summary');
      if (sum && /^\s*tabela rozmiar/i.test(sum.textContent)) {
        d.style.display = 'none';
      }
    });
  }

  function init() {
    if (!document.querySelector('.template-product')) return;
    buildHeader();
    buildDrawer();
    hideAccordionSection();

    const target = document.querySelector('.template-product');
    if (!target) return;
    let scheduled = false;
    new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        buildHeader();
        hideAccordionSection();
      }, 100);
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
